/// <amd-module name="VSS/Features/MarkdownEditor/Formatting/Code" />
import { MarkdownSigns, newLineChar, wrapWithSign } from "./Common";
import { IMarkdownFormattingArgs, IMarkdownFormattingResult } from "./Contracts";

export function wrapWithCodeSign(formattingArgs: IMarkdownFormattingArgs): IMarkdownFormattingResult {
    const { text = "" } = formattingArgs;
    const selectionStart = Math.min(formattingArgs.selectionStart || 0, text.length);
    const selectionEnd = Math.min(formattingArgs.selectionEnd || 0, text.length);

    const selectedText = text.substring(selectionStart, selectionEnd);
    const isMultiline = selectedText.trim().indexOf(newLineChar) >= 0;
    const sign = isMultiline ? MarkdownSigns.CodeBlock : MarkdownSigns.Code;

    return wrapWithSign(formattingArgs, sign);
}
